<template>
    <div>
        <BaseDatatable :module="`shipments`" :apiurl="url" :fields="fields"></BaseDatatable>
    </div>
</template>

<script>
import BaseDatatable from '../../core/BaseDatatable'

export default {
  name: 'ShipmentList',
  props: ['url'],
  components: {BaseDatatable},
  data () {
    return {
      apiurl: this.url,
      fields: [
        {
          name: 'name',
          sortField: 'name',
          title: this.$translate.t('Name')
        },
        {
          name: 'price_formatted',
          sortField: 'price',
          title: this.$translate.t('Ár')
        },
        {
          name: '__slot:actions',
          title: this.$translate.t('Actions')
        }
      ],
      roles: {},
      page: 1,
      filters: {}
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Shipment List'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/shipment/ShipmentList.vue